import { render, staticRenderFns } from "./configuracoesImpresaoPDF.vue?vue&type=template&id=89d8c0da"
import script from "./configuracoesImpresaoPDF.ts?vue&type=script&lang=js&external"
export * from "./configuracoesImpresaoPDF.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89d8c0da')) {
      api.createRecord('89d8c0da', component.options)
    } else {
      api.reload('89d8c0da', component.options)
    }
    module.hot.accept("./configuracoesImpresaoPDF.vue?vue&type=template&id=89d8c0da", function () {
      api.rerender('89d8c0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/relatorio/configuracoesImpresaoPDF.vue"
export default component.exports